export type OgImageProps = {
  title: string;
  subtitle?: string;
  path?: string;
  ogUrl: string;
};

const getOgImageUrl = ({ title, subtitle, path, ogUrl }: OgImageProps) => {
  const url = new URL(ogUrl);
  const queries = Object.entries({ title, subtitle, path }).filter((arr) => !!arr[1]);

  for (let idx = 0; idx < queries.length; idx++) {
    if (queries[idx].length === 2 && typeof queries[idx][1] === "string") {
      url.searchParams.append(queries[idx][0], queries[idx][1] as string);
    }
  }

  return url.href;
};

export const getOgImages = (data: OgImageProps) => {
  return [{ width: 1200, height: 630, url: getOgImageUrl(data) }];
};
